/**
 * Created by tomnotcat on 2024/1/3.
 */
import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { View, TextInput, Text, Image, ViewPropTypes, Platform,
         StyleSheet, TouchableOpacity, TouchableWithoutFeedback } from "react-native";
import AppConfig from "../../config/AppConfig";
import * as Helper from "../../utils/Helper";
import AntdIcon from "react-native-vector-icons/AntDesign";
import MessageBox from "./MessageBox";
import ImagePickerModal from "./ImagePickerModal";
import EmojiSelector from "./EmojiSelector";
import EmojiManager from '../../utils/EmojiManager';
import RichEdit from "./RichEdit";
import ApiService from "../../services/ApiService";
import UIDs from "../../UIDs";
import { ReplaceUrlWithVirtualPath } from "../../../components/ui/HTMLEditor";

const uid = UIDs.components.ui.replyInput;

class ReplyInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: '',
            textLen: 0,
            images: [],
            uploading: false,
            showEmoji: false,
        }
    }

    componentDidMount() {
        this.setState({
            text: this.props.defaultText || '',
            images: this.props.defaultImages || [],
        })

        if(this.props.defaultText && this._edit){
            this._edit._initHtml = this.props.defaultText;
            this._edit.setHtml(this.props.defaultText);
        }
    }

    componentWillUnmount() {
        this._unmounted = true;
    }

    componentDidUpdate(prevProps, prevState) {
    }

    _setupEdit = (r) => {
        this._edit = r;
    };

    _setupImagePicker = (r) => {
        this._imagePicker = r;
    };

    _handleContentLength = (n) => {
        this.setState({textLen: n});
    };

    _handleChangeText = (v) => {
        this.setState({text: v});
    };

    _handleNoop = () => {
    };

    _handleAddEmoji = () => {
        this.setState({showEmoji: !this.state.showEmoji});
        this._edit.blur();
    };

    _onSelectEmoji = (item) => {
        const url = EmojiManager.getImage(item);
        if (url) {
            this._edit.insertImage({uri: url});
        }
    };

    _handleAddImage = () => {
        const maxCount = 5;
        if (this.state.images.length >= maxCount) {
            MessageBox.danger(this.props.t('maxUploadImage', {count: maxCount}));
            return;
        }

        if (!this._imagePicker) {
            return;
        }

        if (this._pendingImagePicker) {
            return;
        }

        this._pendingImagePicker = true;
        const options = {
            quality: 1.0,
            maxWidth: 500,
            maxHeight: 500,
            storageOptions: {
                skipBackup: true,
                waitUntilSaved: true,
            },
            title: this.props.t("imagePickerTitle"),
            cancelButtonTitle: this.props.t("cancelButtonTitle"),
            takePhotoButtonTitle: this.props.t("takePhotoButtonTitle"),
            chooseFromLibraryButtonTitle: this.props.t("chooseFromLibraryButtonTitle"),
        };

        this._imagePicker.showImagePicker(options, (response) => {
            this._pendingImagePicker = false;
            if (response.didCancel) {
                console.log("User cancelled photo picker");
            } else if (response.errorMessage) {
                MessageBox.danger(response.errorMessage);
            } else {
                /*
                let uriPost;
                if (Platform.OS === "android") {
                    uriPost = response.uri;
                } else {
                    uriPost = response.uri.replace("file://", "");
                }

                let fileName = "replyPost" + _.now() + ".jpg";//as temp file name since if take photo the ios will has no name
                if (response.fileName) {
                    fileName = response.fileName;
                }

                let file = { uri: uriPost, type: "multipart/form-data", name: fileName };
                */
                let file = response;

                this.setState({uploading: true});
                let formData = new FormData();
                formData.append("fileData", file);
                formData.append("table", "BbsReplies");
                formData.append("field", "Data");
                formData.append("clientType", 1);
                formData.append("clientVersion", AppConfig.APP_CLIENT_VERSION);
                formData.append("clientBuild", AppConfig.APP_CLIENT_BUILD);
                formData.append("timeZone", Helper.getTimeZone());
                formData.append("fileData", file);

                ApiService.post("/common/file/upload", formData,
                                (response) => {
                                    const images = _.clone(this.state.images);
                                    images.push(response.virtualPath);
                                    this._imagePicker._handleClose();
                                    this.setState({images, uploading: false});
                                }, (error) => {
                                    this._imagePicker._handleClose();
                                    this.setState({uploading: false});
                                    MessageBox.danger({ text: error.message, duration: 5000 });
                                });
            }
        });
    };

    _handleSend = () => {
        if (this._edit) {
            const html = this._edit.getHtml();
            if (html && this.props.onSubmit) {
                this.props.onSubmit(ReplaceUrlWithVirtualPath(html), this.state.images);
            }
            return;
        }

        if (this.props.onSubmit) {
            this.props.onSubmit(this.state.text, this.state.images);
        }
    };

    _handleClose = () => {
        if (this.state.showEmoji) {
            this.setState({showEmoji: false});
            return;
        }

        if (this.props.onClose) {
            this.props.onClose(this._edit ? this._edit.getHtml() : "", this.state.images);
        }
    };

    _renderImage = (it, i) => {
        return (<View key={i} style={{width: 52, height: 52, borderWidth: 1, borderColor: '#999',
                                      marginRight: 8, alignItems: 'center', justifyContent: 'center'}}>
                    <Image style={{width: 50, height: 50}}
                           source={{uri: Helper.convertToAbsoluteUrl(it)}}/>
                    <TouchableOpacity style={{position: 'absolute', right: -6, top: -6,
                                              width: 16, height: 16, borderRadius: 8,
                                              alignItems: 'center', justifyContent: 'center',
                                              zIndex: 1, backgroundColor: '#ff0000'}}
                                      onPress={() => {
                                          const images = _.clone(this.state.images);
                                          images.splice(i, 1);
                                          this.setState({images});
                                      }}>
                        <AntdIcon name={"close"} style={{ fontSize: 12, color: '#fff' }} />
                    </TouchableOpacity>
                </View>);
    };

    _renderBody() {
        const disabled = (this.state.images.length == 0) && (!this.state.text.trim()) && (this.state.textLen < 1);
        return (
            <View>
                <View style={{flexDirection: 'column', height: 245, backgroundColor: '#fff',
                              borderTopLeftRadius: 10, borderTopRightRadius: 10, padding: 10, overflow: 'hidden'}}>
                    <RichEdit ref={this._setupEdit} style={{height: 200}} maxImage={500} maxLength={500}
                              imageHeight={26} onContentLength={this._handleContentLength}/>
                    {/*
                    <TextInput multiline={true} maxLength={500} autoFocus={true}
                               value={this.state.text}
                               placeholder={this.props.t('replyTo', {name: this.props.toUserName})}
                               onChangeText={this._handleChangeText}
                               style={{flex: 1, height: 200, textAlignVertical: 'top'}}/>
                     */}
                    {this.state.images.length > 0 ?
                     (<View style={{marginTop: 8, marginBottom: 8,
                                    flexDirection: 'row', alignItems: 'center'}}>
                          {this.state.images.map(this._renderImage)}
                      </View>) : null}
                    <View style={{flexDirection: 'row', alignItems: 'center',
                                  paddingLeft: 10, paddingRight: 10}}>
                        <TouchableOpacity onPress={this._handleAddEmoji}
                                          onMouseDown={(e) => e.preventDefault()}>
                            <AntdIcon name={"smileo"} style={{ fontSize: 26, color: '#333' }} />
                        </TouchableOpacity>
                        <TouchableOpacity onPress={this._handleAddImage}>
                            <AntdIcon name={"picture"} style={{ marginLeft: 20, fontSize: 26, color: '#333' }} />
                        </TouchableOpacity>
                        <View style={{flex: 1}}/>
                        <TouchableOpacity style={{alignItems: 'center', justifyContent: 'center',
                                                  height: 28, borderRadius: 19,
                                                  paddingLeft: 10, paddingRight: 10,
                                                  backgroundColor: (disabled ? '#83cafb' : '#458EF7')}}
                                          disabled={disabled}
                                          onPress={this._handleSend}>
                            <Text style={{color: '#fff'}}>{this.props.t('send')}</Text>
                        </TouchableOpacity>
                    </View>
                    <ImagePickerModal ref={this._setupImagePicker}/>
                </View>
                {this.state.showEmoji ? (<EmojiSelector style={{height: 200}} onSelect={this._onSelectEmoji}/>) : null}
                {this.state.uploading ?
                 (<View style={{zIndex: 1, position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
                                alignItems: 'center', justifyContent: 'center',
                                backgroundColor: 'rgba(0,0,0,0.5)'}}>
                      <Text style={{color: '#fff'}}>{this.props.t('uploading')}</Text>
                  </View>) : null}
            </View>
        );
    }

    render() {
        return (<View style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
                              zIndex: 1, backgroundColor: 'rgba(0,0,0,0.5)'}}>
                    <TouchableWithoutFeedback onPress={this._handleClose}>
                        <View style={{flex: 1}}>
                            <View style={{flex: 1}}/>
                            <TouchableWithoutFeedback onPress={this._handleNoop}>
                                {this._renderBody()}
                            </TouchableWithoutFeedback>
                        </View>
                    </TouchableWithoutFeedback>
                </View>);
    }
}

const styles = StyleSheet.create({
    inputTextStyle: {
        //fontSize: 14,
        color: "#ccc",
        marginRight: 10,
    },
    image: {
        width: 36,
        height: 36,
        marginRight: 10,
        backgroundColor: "#f3f9fc",
    },
});

export default withTranslation(uid, { withRef: true })(ReplyInput);
